/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Admin-initiated password set request
 */
export interface AdminSetPasswordRequest {
  newPassword: string;
}
